import { Navigate, RouteObject } from "react-router";
import { OrdersIndexRoute } from "@/routes/processes/[processId]/htz/orders/orders-index";
import { OrderRoute } from "@/routes/processes/[processId]/htz/orders/[orderId]/order-route";
import { DataRoute } from "@/routes/processes/[processId]/htz/orders/[orderId]/data/data-route";
import { PositionsRoute } from "@/routes/processes/[processId]/htz/orders/[orderId]/positions/positions-route";
import { AddressesAndContactsRoute } from "@/routes/processes/[processId]/htz/orders/[orderId]/addresses-and-contacts/addresses-and-contacts-route";
import { OrderFilesRoute } from "@/routes/processes/[processId]/htz/orders/[orderId]/files/order-files-route";

export const htzOrdersRoutes: RouteObject[] = [
  {
    index: true,
    element: <OrdersIndexRoute />,
  },
  {
    path: ":orderId",
    element: <OrderRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="data" replace />,
      },
      {
        path: "data",
        element: <DataRoute />,
      },
      {
        path: "positions",
        element: <PositionsRoute />,
      },
      {
        path: "addresses-and-contacts",
        element: <AddressesAndContactsRoute />,
      },
      {
        path: "files",
        element: <OrderFilesRoute />,
      },
    ],
  },
];
